exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n#timetableHeader[data-v-47a6e666]{\n  box-sizing: border-box;\n  width: auto;\n  z-index: 1001;\n  /*table-layout: fixed;*/\n}\nthead[data-v-47a6e666] {\n  box-sizing: border-box;\n  margin-left: -1px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-47a6e666","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/timetable/TimetableHeader.vue
// module id = 505
// module chunks = 0